export default {
  state: {
    CurrentUser: "",
    Users: []
  },
  mutations: {
    setCurrentUser(state, user) {
      state.CurrentUser = user;
    },
    setUser(state, users) {
      state.Users = users;
    },
    addUsers(state, user) {
      state.Users.push(user);
    },
    upUsers(state, user) {
      let index = state.Users.findIndex(x => x.user_id === user.user_id);
      state.Users.splice(index, 1, user);
    },
    deleteUsers(state, id) {
      let index = state.Users.findIndex(x => x.user_id === id);
      state.Users.splice(index, 1);
    }
  }
};
